import React from "react"
import LayoutModal from "../../organisms/layoutModal/layout-modal"
import logoWhathsapp from "../../../assets/images/whatsapp-icon.png"
import logoFacebook from "../../../assets/images/facebook.svg"
import "./modal-share.scss"

const ModalShare = ({ hideAction }) => {

    const dataLayer = (redSocialName) => {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
            'event': 'ga_event_consultorio',
            'category': 'AcademiaTENA',
            'action': 'Compartir',
            'label': redSocialName,
            'value': ''
        });
    }

    return (
        <LayoutModal>
            <div className="f-modal-share">
                <div className="f-card-modal-head">
                    <span
                        className="f-card-modal-head-icon"
                        onClick={hideAction}
                    >
                        X
                    </span>
                </div>
                <h3 className="f-modal-share-title">
                    Comparte nuestro contenido <span>TENA</span> , con tus
                    familiares y amigos.
                </h3>
                <p className="f-modal-share-copy">
                    Selecciona la red social en la que quieres compartir este
                    video:
                </p>
                <div>
                    <a
                        className="f-modal-share__btn f-whatsapp-icon"
                        href={`https://wa.me/?text=Me+gustar%C3%ADa+que+vieras+este+evento+de+TENA%2C+${window.location.href}`}
                        target="_blank"
                        onClick={() => dataLayer("WhatsApp")}
                    >
                        <img src={logoWhathsapp} />
                    </a>
                    <a
                        className="f-modal-share__btn"
                        href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`}
                        target="_blank"
                        onClick={() => dataLayer("Facebook")}
                    >
                        <img src={logoFacebook} />
                    </a>
                </div>
                {/* <button
                    type="button"
                    className="f-modal-share__button"
                    onClick={hideAction}
                >
                    COMPARTIR
                </button> */}
            </div>
        </LayoutModal>
    )
}

export default ModalShare
